



























import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import { ValueListItem, SystemApi, WorkersApi } from 'performo-api';

@Component({ components: {} })
export default class WorkerPicker extends Vue {
  @Prop({ required: true })
  private value!: string;

  @Prop({ required: false, default: '' })
  private propertyId?: string;

  @Prop({ required: false, default: 'Worker' })
  private labelOverride?: string;

  @Prop({ required: false, default: 'VLIST' })
  private workerSourceList?: string;

  get getValue() {
    return this.value ? this.value : '';
  }

  get currentPropertyId(): string {
    return this.$store.getters.currentPropertyId;
  }

  private systemApi: SystemApi = new SystemApi(
    this.$store.getters.getApiConfiguration
  );
  private workerApi: WorkersApi = new WorkersApi(
    this.$store.getters.getApiConfiguration
  );

  private workers: ValueListItem[] = [];

  get workersSorted(): ValueListItem[] {
    if (!this.workers) {
      return [];
    }
    return this.workers; // sorted from back end, if different sort is needed override here with .sort((a,b)=>{});
  }

  private changeHandler() {
    const pickedValue: string = (this.$refs.selectedValue as HTMLSelectElement)
      .value;
    // always emit the input event, so this control works like a regular <select> element.
    this.$emit('input', pickedValue);
  }

  @Watch('currentPropertyId')
  async currentPropertyIdChanged() {
    await this.refreshWorkers(this.currentPropertyId);
  }

  @Watch('propertyId')
  async propertyIdChanged() {
    if (this.propertyId) {
      await this.refreshWorkers(this.propertyId);
    }
  }

  async refreshWorkers(propertyId: string) {
    // blank
    this.workers = [];

    if (this.workerSourceList === 'VLIST') {
      this.workers = await this.systemApi.getValueListItems({
        name: 'Workers',
        propertyId: propertyId
      });
      return;
    }

    if (this.workerSourceList === 'REASSIGN') {
      this.workers = await this.workerApi.reassignValueList({
        propertyId: propertyId
      });
    }
  }

  private async mounted() {
    await this.refreshWorkers(
      this.propertyId ? this.propertyId : this.currentPropertyId
    );
  }

  public workerListContains(workerName: string) {
    let found = false;
    this.workers.forEach((element) => {
      if (element.valueListValue === workerName) {
        found = true;
      }
    });
    return found;
  }
}
